import { configureStore, combineReducers, Reducer } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
// import thunk from "redux-thunk"
// import reducer from "./reducer"
// import postReducer from './counterSlice';
import appReducer from './app';

const modulesFiles = {
    app: appReducer
};
const rootReducer = combineReducers(modulesFiles);


export const store = configureStore({
    reducer: rootReducer,
    // reducer: {
    //     articles: reducer
    // },
    // devTools: true
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector